import "./styles.scss";

import { faCog, faSignOut, faUser, faBars, faMessage, faMusic, faMicrophone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "react-bootstrap/Dropdown";
import { Link, Outlet } from "react-router-dom";
import Brand from "../../components/Brand";
import agentIcon from "../../assets/agent_icon.png";
import walletIcon from "../../assets/wallet_icon_cropped.png";
import { useCurrentUser } from "../../UserProvider";
import Avatar from "../../components/Avatar/Avatar";

export default function Main() {
  const { currentUser } = useCurrentUser();

  return (
    <div className="__main">
      <div className="root">
        <header className="main-header">
          <div className="main-header__container container">
            <div className="main-header__head">
              <Link to="/" className="header__brand brand">
                <Brand.Logo height={ 56 } className="brand__logo" />
              </Link>
              <div className="main-header__jobs">
                <Link to="/chat" className="button button--white button--link agent-nav-link">
                  <img src={agentIcon} alt="Your Agent" className="agent-nav-icon" />
                  Your Agent
                </Link>
                <Link to="/jobs" className="button button--white button--link">
                  <FontAwesomeIcon icon={faMusic} /> Jobs
                </Link>
                <Link to="/wallet" className="button button--white button--link agent-nav-link">
                  <img src={walletIcon} alt="Wallet" className="agent-nav-icon wallet-nav-icon" />
                  Wallet
                </Link>
                <Link to="/artists" className="button button--white button--link">
                  <FontAwesomeIcon icon={faMicrophone} /> Artists
                </Link>
                {currentUser &&
                  <Link to="/inbox" className="button button--white button--link">
                    <FontAwesomeIcon icon={faMessage} /> Inbox
                  </Link>
                }
              </div>
              { !currentUser && (
                <div className="main-header__button-group">
                  <Link to="/login" className="button button--white button--link">
                    Login
                  </Link>
                  <Link to="/signup" className="button button--white button--fill">
                    Sign Up
                  </Link>
                </div>
              ) }
              { currentUser && (
                <Dropdown align="end" className="user-dropdown">
                  <Dropdown.Toggle as="div" bsPrefix="custom-toggle" className="dropdown__toggle account">
                    <Avatar
                      profile={{ ...currentUser.profile, user_id: currentUser.id }}
                      className="account__icon"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown__menu">
                    { currentUser.is_admin && (
                      <div className="dropdown__admin-menu">
                        <Dropdown.Item as={Link} to="/user-data" className="dropdown__item">
                          User Data
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to="/rss-feeds" className="dropdown__item">
                          RSS Feeds
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to="/facebook-candidates" className="dropdown__item">
                          FB Candidates
                        </Dropdown.Item>
                      </div>
                    )}
                    <Dropdown.Item as={Link} to={`/a/${currentUser.display_name}`} className="dropdown__item">
                      <FontAwesomeIcon icon={faUser} /> Profile
                    </Dropdown.Item>
                    {currentUser.registered &&
                      <Dropdown.Item as={Link} to="/account-settings" className="dropdown__item">
                        <FontAwesomeIcon icon={faCog} /> Account settings
                      </Dropdown.Item>
                    }
                    <Dropdown.Item as={Link} to="/logout" className="dropdown__item">
                      <FontAwesomeIcon icon={faSignOut} /> Sign out
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) }
              <Dropdown align="end" className="burger-dropdown">
                <Dropdown.Toggle as="div" bsPrefix="custom-toggle" className="dropdown__toggle account">
                  <FontAwesomeIcon icon={faBars} className="account__icon" />
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown__menu">
                  { !currentUser && (
                    <>
                      <Dropdown.Item as={Link} to="/chat" className="dropdown__item">
                        Your Agent
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/jobs" className="dropdown__item">
                        <FontAwesomeIcon icon={faMusic} /> Jobs
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/wallet" className="dropdown__item">
                        <img src={walletIcon} alt="" className="agent-nav-icon wallet-nav-icon" /> Wallet
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/artists" className="dropdown__item">
                        <FontAwesomeIcon icon={faMicrophone} /> Artists
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/login" className="dropdown__item">
                        Login
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/signup" className="dropdown__item">
                        Sign Up
                      </Dropdown.Item>
                    </>
                  )}

                  { currentUser && (
                    <>
                      { currentUser.is_admin && (
                        <div className="dropdown__admin-menu">
                          <Dropdown.Item as={Link} to="/user-data" className="dropdown__item">
                            User Data
                          </Dropdown.Item>
                          <Dropdown.Item as={Link} to="/rss-feeds" className="dropdown__item">
                            RSS Feeds
                          </Dropdown.Item>
                          <Dropdown.Item as={Link} to="/facebook-candidates" className="dropdown__item">
                            FB Candidates
                          </Dropdown.Item>
                        </div>
                      )}
                      <Dropdown.Item as={Link} to="/inbox" className="dropdown__item">
                        <FontAwesomeIcon icon={faMessage} /> Inbox
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/jobs" className="dropdown__item">
                        <FontAwesomeIcon icon={faMusic} /> Jobs
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/artists" className="dropdown__item">
                        <FontAwesomeIcon icon={faMicrophone} /> Artists
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to={`/a/${currentUser.display_name}`} className="dropdown__item">
                        <FontAwesomeIcon icon={faUser} /> Profile
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to={`/chat`} className="dropdown__item">
                        Your Agent
                      </Dropdown.Item>
                      {currentUser.registered &&
                        <Dropdown.Item as={Link} to="/account-settings" className="dropdown__item">
                          <FontAwesomeIcon icon={faCog} /> Account settings
                        </Dropdown.Item>
                      }
                      <Dropdown.Item as={Link} to="/logout" className="dropdown__item">
                        <FontAwesomeIcon icon={faSignOut} /> Sign out
                      </Dropdown.Item>
                    </>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </header>
        <main className="main">
          <Outlet />
        </main>
        {/*
          <footer className="footer">
            <div className="footer__container container">
              <Link to="/" className="footer__brand brand">
                <Brand.Logo height={ 56 } className="brand__logo" />
              </Link>
              <nav className="footer__nav nav">
                <ul className="nav__list">
                  <li className="nav__item">
                    <span className="item">
                      © { new Date().getFullYear() } Papaya
                    </span>
                  </li>
                  <li className="nav__item">
                    <a href="/privacy" rel="noopener noreferrer" target="_blank" className="item item__link">
                      Privacy Police
                    </a>
                  </li>
                  <li className="nav__item">
                    <a href="/terms" rel="noopener noreferrer" target="_blank" className="item item__link">
                      Terms and conditions
                    </a>
                  </li>
                  <li className="nav__item">
                    <a href={ `mailto:${ process.env.REACT_APP_CONTACT_EMAIL }` } className="item item__link">
                      Contact us
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </footer>
        */}
      </div>
    </div>
  )
}
